module.exports = __webpack_public_path__ + "img/cvf-poa.ac33045f.png";